import { Role } from "../user/user.types";

export const navigationConfig = [
  // {
  //   title: 'Accueil',
  //   icon: 'heroicons_solid:home',
  //   subtitle: '',
  //   link: 'dashboard',
  //   id: 'dashboard',
  //   type: 'basic',
  //   canDelete: false,
  //   children: [],
  // },
  {
    title: 'Projets',
    icon: 'heroicons_solid:briefcase',
    subtitle: '',
    link: 'projects',
    id: 'projects',
    type: 'basic',
    canDelete: false,
    children: [],
  },
  {
    title: 'Clients',
    icon: 'heroicons_solid:briefcase',
    subtitle: '',
    link: 'customers',
    id: 'customers',
    type: 'basic',
    canDelete: false,
    children: [],
  },
  {
    roles: [Role.Admin],
    title: 'Configurations',
    icon: 'heroicons_solid:cog-8-tooth',
    subtitle: '',
    link: 'configurations',
    id: 'configurations',
    type: 'basic',
    canDelete: false,
    children: [],
  },
];